import { LeftOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { Option } from "antd/es/mentions";
import { BUSINESS_TYPE } from "../../util/Constant";
import {
  fetchStart,
  fetchSuccess,
  getCategoryListAction,
  getHSCodeAction,
} from "../../appRedux/actions";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const AddEditBannerPromotion = () => {
  const history = useHistory();
  const { id } = useParams();
  let isEdit = isValidElement(id);
  const [form] = useForm();
  const FormItem = Form.Item;
  const { TextArea } = Input;
  const authUser = useSelector(({ auth }) => auth.userData);
  const hsCodeList = useSelector((state) => state.myProducts.hsCodeList);
  const [hsCodeData, setHsCodeData] = useState(null);
  const [targetedBusinessType, setTargetedBusinessType] = useState(null);
  const [bannerType, setBannerType] = useState(null);
  const [urlType, setUrlType] = useState(null);

  const onBannerTypeChange = (selectedValue) => {
    form.setFieldsValue({ bannerType: selectedValue });
    setBannerType(selectedValue);
  };

  const onURLTypeChange = (selectedValue) => {
    setUrlType(selectedValue);
    form.setFieldsValue({ urlType: selectedValue });
  };

  const onBusinessTypeChange = (value) => {
    setTargetedBusinessType([value]);
  };
  const [PromotionData, setPromotionData] = useState(null);
  const [displayedHsCode, setDisplayedHsCode] = useState(null);
  const dispatch = useDispatch();

  const getPromotionById = async (promoid) => {
    if (isValidString(promoid)) {
      dispatch(fetchStart());
      try {
        const promotionById = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/broadcastpromotions/${promoid}`
        );
        setPromotionData(promotionById?.data?.data);
      } catch (error) {
        console.error("Error fetching promotion:", error);
      } finally {
        dispatch(fetchSuccess());
      }
    }
  };

  useEffect(() => {
    if (PromotionData?.hsCodeId) {
      if (!hsCodeList) {
        dispatch(getHSCodeAction());
        return;
      }
      const selectedHsCode = hsCodeList.find(
        (item) => item.id === PromotionData.hsCodeId
      );
      if (selectedHsCode) {
        const formattedHsCode = `${selectedHsCode.code} - ${selectedHsCode.description}`;
        setDisplayedHsCode(formattedHsCode);
        form.setFieldsValue({ hscode: PromotionData.hsCodeId });
      } else {
        setDisplayedHsCode(null);
      }
    } else {
      setDisplayedHsCode(null);
    }
  }, [PromotionData, hsCodeList, form, dispatch]);

  useEffect(() => {
    getPromotionById(id);
    dispatch(getCategoryListAction());
    dispatch(getHSCodeAction());
  }, [dispatch, id]);

  useEffect(() => {
    if (PromotionData?.id) {
      const formattedStartDate = moment(PromotionData?.startDate).format(
        "DD-MM-YYYY"
      );
      const formattedEndDate = moment(PromotionData?.endDate).format(
        "DD-MM-YYYY"
      );

      form.setFieldsValue({
        promotionTitle: PromotionData?.title,
        promotionMessage: PromotionData?.description,
        promotionStart: moment(formattedStartDate, "DD-MM-YYYY"),
        promotionEnd: moment(formattedEndDate, "DD-MM-YYYY"),
        parties: PromotionData?.targetedBusinessType?.[0],
        bannerType: PromotionData?.bannerType,
        urlType: PromotionData?.urlType,
        urlDetails: PromotionData?.url,
      });

      setBannerType(PromotionData?.bannerType);
      setUrlType(PromotionData?.urlType);

      if (PromotionData?.targetedBusinessType) {
        setTargetedBusinessType(PromotionData.targetedBusinessType);
      }

      if (PromotionData?.categoryId) {
        setHsCodeData(
          hsCodeList?.filter(
            (item) => item?.categories?.id === PromotionData.categoryId
          )
        );
      }
    }
  }, [PromotionData, form]);

  const onFinish = async (values) => {
    try {
      const data = {
        title: values?.promotionTitle,
        description: values?.promotionMessage,
        category: values?.promotionCategory,
        categoryId: values?.productCategory,
        hsCodeId: values?.hscode,
        startDate: values?.promotionStart,
        endDate: values?.promotionEnd,
        countryId: values?.destinationCountry,
        portId: values?.destinationPort,
        targetedBusinessType: targetedBusinessType,
        userId: authUser?.id,
        bannerType: bannerType,
        urlType: urlType,
        url: values?.urlDetails,
      };
      if (isEdit) {
        const response = await axiosInstance.put(
          `${BASE_API_CONFIG.baseURL}/broadcastpromotions/${id}`,
          data
        );
        if (response.status === 200) {
          message.success("success", "Promotion saved successfully");
          history.goBack();
        } else {
          message.error("error", "Failed to save promotion");
        }
      } else {
        const response = await axiosInstance.post(
          `${BASE_API_CONFIG.baseURL}/broadcastpromotions`,
          data
        );
        if (response.status === 200) {
          message.success("success", "Promotion saved successfully");
          history.goBack();
        } else {
          message.error("error", "Failed to save promotion");
        }
      }
    } catch (error) {
      message.error("error", "An error occurred while saving promotion");
      console.error("Error:", error);
    }
  };

  return (
    <Card
      className="gx-card myexim-detail-card"
      title={
        <div className="myexim-table-title gx-text-capitalize">
          <LeftOutlined
            className={"back-icon"}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          {isEdit ? "Edit" : "Add"} Banner Promotion
        </div>
      }
    >
      <Form form={form} onFinish={onFinish} scrollToFirstError={true}>
        <Row gutter={16}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={"Select the Party who you would like to send Promotions"}
              name="parties"
              rules={[
                {
                  required: true,
                  message: "Party is required",
                },
              ]}
            >
              <Select
                placeholder="Select Party"
                onChange={(selectedParty) =>
                  onBusinessTypeChange(selectedParty)
                }
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                <Option value={BUSINESS_TYPE.BUYER}>Buyer</Option>
                <Option value={BUSINESS_TYPE.EXPORTER}>Exporter</Option>
                <Option value={BUSINESS_TYPE.MANUFACTURER_EXPORTER}>
                  Manufacturer Cum Exporter
                </Option>
                <Option value={BUSINESS_TYPE.MANUFACTURER}>
                  Manufacturers
                </Option>
                <Option value={BUSINESS_TYPE.COMMISSION_AGENT}>
                  Commission Agents
                </Option>
                <Option value={BUSINESS_TYPE.CUSTOM_HOUSE_AGENT}>
                  Custom House Agent(CHA)
                </Option>
                <Option value={BUSINESS_TYPE.FREIGHT_FORWARDER}>
                  Freight Forwarders
                </Option>
                <Option value={BUSINESS_TYPE.SHIPPING_LINE}>
                  Shipping Lines
                </Option>
                <Option value={BUSINESS_TYPE.CUSTOMHOUSEAGENTS_FREIGHTFORWARDER}>
                  Custom House Agents Cum Freight Forwarders
                </Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={"Select Promotion Banner type"}
              name="bannerType"
              rules={[
                {
                  required: true,
                  message: "Party is required",
                },
              ]}
            >
              <Select
                placeholder="Select Party"
                onChange={onBannerTypeChange}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                <Option value="type_1">Type 1 (large)</Option>
                <Option value="type_2">Type 2 (small)</Option>
                <Option value="type_3">Type 3 (small)</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={"Select URL Type"}
              name="urlType"
              rules={[
                {
                  required: true,
                  message: "URL is required",
                },
              ]}
            >
              <Select
                placeholder="Select URL Type"
                onChange={onURLTypeChange}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                <Option value="internal_url">Internal URL</Option>
                <Option value="external_url">External URL</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Action url"
              name="urlDetails"
              rules={[
                {
                  required: true,
                  message: "URL is required",
                },
              ]}
            >
              <Input autoComplete={"off"} placeholder={"Enter the URL "} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Promotion Title"
              name="promotionTitle"
              rules={[
                {
                  required: true,
                  message: "Promotion Title is required",
                },
              ]}
            >
              <Input
                autoComplete={"off"}
                placeholder={"Enter Promotion Title "}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <FormItem
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Promotion Start"
              name="promotionStart"
              rules={[
                {
                  required: true,
                  message: "Promotion Start is required",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </FormItem>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Promotion End"
              name="promotionEnd"
              rules={[
                {
                  required: true,
                  message: "Promotion End is required",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                getPopupContainer={(trigger) => trigger.parentNode}
                disabledDate={(currentDate) => {
                  const promotionStartDate =
                    form.getFieldValue("promotionStart");
                  return (
                    currentDate && currentDate.isBefore(promotionStartDate)
                  );
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Promotion Message"
              name="promotionMessage"
              rules={[
                {
                  required: true,
                  message: "Promotion Message is required",
                },
                {
                  max: 110,
                  message: "Promotion Message cannot exceed 110 characters",
                },
              ]}
            >
              <div style={{ position: "relative" }}>
                <TextArea
                  rows={4}
                  placeholder="Provide More details about promotion message with specifications."
                  maxLength={110}
                />
                <Form.Item noStyle shouldUpdate>
                  {() => (
                    <div
                      style={{
                        position: "absolute",
                        right: 8,
                        bottom: 8,
                        color:
                          (form.getFieldValue("promotionMessage")?.length ||
                            0) >= 110
                            ? "#ff4d4f"
                            : "rgba(0, 0, 0, 0.45)",
                        backgroundColor: "white",
                        padding: "0 4px",
                        borderRadius: 2,
                        fontSize: 12,
                      }}
                    >
                      {110 -
                        (form.getFieldValue("promotionMessage")?.length || 0)}
                    </div>
                  )}
                </Form.Item>
              </div>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              className="gx-text-center"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "15px",
              }}
            >
              <Button
                type="secondary"
                size="large"
                style={{ width: 150 }}
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                style={{ width: 150 }}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default AddEditBannerPromotion;
